import { render, staticRenderFns } from "./ContactMassEditItem.vue?vue&type=template&id=71139af1&scoped=true&"
import script from "./ContactMassEditItem.vue?vue&type=script&lang=js&"
export * from "./ContactMassEditItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactMassEditItem.vue?vue&type=style&index=0&id=71139af1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71139af1",
  null
  
)

export default component.exports